
import React from 'react';
import Grid from '@mui/material/Grid2';

interface Props { 
  color?: string;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const height = "9px";
const width = "27px";

export default function ColorsButton({ 
  color = "",
  onClick
}: Props) {
  return (
    <div className="clickable" style={{ 
        width,
        border: `2px solid ${color}` 
      }}>
      <Grid container spacing={0} direction="row" 
        onClick={onClick}>
        <Grid
          style={{ backgroundColor: "red", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "green", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "blue", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "yellow", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "orange", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "purple", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "black", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "gray", height }}
          size={{
            xs: 4
          }}></Grid>
        <Grid
          style={{ backgroundColor: "white", height }}
          size={{
            xs: 4
          }}></Grid>
      </Grid>
    </div>
  );
}
